module.exports = __webpack_public_path__ + "img/classic_m6.af342af9.png";